<script setup lang="ts">
import { computed } from '#imports';

const colorMode = useColorMode();
const darkMode = computed(() => colorMode.preference === 'dark' || (colorMode.preference === 'system' && colorMode.value === 'dark'));
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <!-- Hintergrund -->
    <!--    <rect width="512" height="512" fill="#1a2332" />-->
    <rect width="512" height="512" fill="transparent" />

    <!-- Ring -->
    <circle cx="256" cy="256" r="180" :fill="darkMode ? '#f5f5f5' : '#1a2332'" />

    <!-- Innerer dunkler Kreis -->
    <circle cx="256" cy="256" r="95" :fill="darkMode ? '#1a2332' : '#f5f5f5'" />

    <!-- Cyan Akzent-Punkt -->
    <circle cx="360" cy="155" r="42" fill="#00d4ff" />
  </svg>
</template>
<style scoped></style>
